import { Result, Skeleton } from 'antd';
import ArticlesList from 'components/ArticlesList';
import OctobreRoseCard from 'components/cards/OctobreRoseCard';
import InfoHome from 'components/info/InfoHome';
import { useCategoryPage } from 'components/info/queries';
import PageTopBar from 'components/navigation/PageTopBar';
import useScrollRestoration from 'hooks/useScrollRestoration';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { INFO_ROOT_SLUG } from 'services/api/ApiContentManager';
import { colors } from 'design';

const useStyles = createUseStyles({
  pageContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: colors.surface.page,
    alignItems: 'center',
  },
  container: {
    padding: '8px 8px 0px',
    height: '100%',
    overflowY: 'scroll',
    maxWidth: 600,
    width: '100%',
  },
  octobreRoseCardContainer: {
    marginBottom: 16,
  },
});

export default function InfoPage() {
  // Hooks
  const { t } = useTranslation();
  const styles = useStyles();
  const scrollableRef = useRef<HTMLDivElement>(null);
  useScrollRestoration(scrollableRef);

  // The categorised Infos page is A/B tested against the flat list: the root
  // category says which one this user gets. An error stays an error (no
  // silent switch to the flat list, which would muddle the analytics).
  const { data: root, isPending, isError } = useCategoryPage(INFO_ROOT_SLUG);

  return (
    <div className={styles.pageContainer}>
      <PageTopBar title={t('menu.info')} />
      <div className={styles.container} ref={scrollableRef}>
        {isPending ? (
          <Skeleton active paragraph={{ rows: 6 }} />
        ) : isError ? (
          <Result status="error" subTitle={t('loginRegister.errors.errorOccurred')} />
        ) : root.variant === 'v2' ? (
          <InfoHome root={root} />
        ) : (
          <>
            <div className={styles.octobreRoseCardContainer}>
              <OctobreRoseCard openedOnPage="info" />
            </div>
            <ArticlesList allowGridView />
          </>
        )}
      </div>
    </div>
  );
}
